import CConsole from './CConsole';

/**
 * @param {string} url - The URL to check and potentially convert
 * @returns {string} - The URL with HTTPS protocol if it was HTTP, otherwise unchanged
 */
export const ensureHttpsUrl = url => {
  try {
    if (!url || typeof url !== 'string') {
      return url;
    }

    if (url.startsWith('http://')) {
      return url.replace('http://', 'https://');
    }
  } catch (error) {
    CConsole.error(`Error in the function [ensureHttpsUrl] received url: ${url} with error: ${error}`);
  }

  return url;
};

/**
 * @param {string[]} urls - Array of URLs to check and potentially convert
 * @returns {string[]} - Array of URLs with HTTPS protocol
 */
export const ensureHttpsUrls = urls => {
  if (!Array.isArray(urls)) {
    return urls;
  }

  return urls.map(url => ensureHttpsUrl(url));
};

/**
 * @param {Object} tag - Tag object
 * @returns {Object} - Tag object with processed HTTPS URLs
 */
export const ensureHttpsForTag = tag => {
  if (!tag || typeof tag !== 'object') {
    return tag;
  }

  return {
    ...tag,
    main_img_url: ensureHttpsUrl(tag.main_img_url),
    retailer_logo: ensureHttpsUrl(tag.retailer_logo),
    logo_image_uri: ensureHttpsUrl(tag.logo_image_uri),
    item_images: ensureHttpsUrls(tag.item_images),
  };
};

/**
 * @param {Array} tags - Array of tags
 * @returns {Array} - Array of tags with processed HTTPS URLs
 */
export const ensureHttpsForTags = tags => {
  if (!Array.isArray(tags)) {
    return tags;
  }

  return tags.map(tag => ensureHttpsForTag(tag));
};
